import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">漫画索引</h2>
          <p className="mt-1 text-sm text-foreground-500">按地区与题材快速定位，发现你的专属漫画世界</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.slice(0, 4).map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-sm font-heading font-bold text-accent-600">{item.count}</span>
                <span className="text-xs text-foreground-400 group-hover:text-primary-500 transition-colors">浏览 <i className="ri-arrow-right-line text-[10px]"></i></span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 md:mt-5 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {indexItems.slice(4, 7).map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-sm font-heading font-bold text-accent-600">{item.count}</span>
                <span className="text-xs text-foreground-400 group-hover:text-primary-500 transition-colors">浏览 <i className="ri-arrow-right-line text-[10px]"></i></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}